import { CountryCode, NumberType, PhoneNumber } from 'libphonenumber-js/core';

import { IMobileValidatorParams } from '~types/validator';

import { string as yupString } from 'yup';
import { isCountryCallingCode } from './phone-number-helper';

const YUP_PHONE_TEST_NAME = 'phone';

type ValidatePhoneNumberFunctionType = (params: {
    phoneNumber?: PhoneNumber;
    countryCode: CountryCode;
    numberType?: NumberType;
}) => boolean;

const validatePhoneNumber: ValidatePhoneNumberFunctionType = ({
    phoneNumber,
    countryCode,
    numberType
}) => {
    return (
        !!phoneNumber &&
        phoneNumber.isValid() &&
        phoneNumber.country === countryCode &&
        // Currently, only mobile metadata set is included, and it can includes both "MOBILE" and
        // "FIXED_LINE_OR_MOBILE" (could be mobile number in CA) type numbers.
        // So when 'MOBILE" is specified in configuration, all number patterns in metadata are
        // allowed.
        (!numberType || numberType === 'MOBILE' || phoneNumber.getType() === numberType)
    );
};

// HACK: A registered FormValidator method accepts up to 2 parameters by design (msg and params, see @estee/elc-form FormValidator), we utilize the 'msg' positional parameter to pass in our custom configs.
export function validateMobile({
    numberType,
    patterns,
    errorMessage = ''
}: IMobileValidatorParams) {
    if (patterns) {
        // support TW multiple area
        /** @ts-ignore */
        const code = this.values.areaCode as string; // `this` is elc-form FormStore
        const regExp = new RegExp(patterns[code] || patterns.default);

        return yupString().matches(regExp, errorMessage);
    } else {
        /** @ts-ignore */
        const { countryCode } = this.values;

        if (!countryCode) {
            return yupString();
        }

        return yupString().test(YUP_PHONE_TEST_NAME, errorMessage, async (value) => {
            if (!value) {
                return true;
            }
            // Align with how `PhoneInput` component set value
            const { createAsYouType, getCountryCodeByCallingCode } = await import(
                './phone-number-helper'
            );
            const alphaCountryCode: CountryCode = isCountryCallingCode(countryCode)
                ? getCountryCodeByCallingCode(countryCode)
                : countryCode;
            const asYouType = createAsYouType(alphaCountryCode);
            asYouType.input(value);

            if (value === `+${asYouType.getCallingCode()}`) {
                return true;
            }

            const phoneNumber = asYouType.getNumber();

            return validatePhoneNumber({ phoneNumber, countryCode: alphaCountryCode, numberType });
        });
    }
}
